import styled from "styled-components";

const GameContentWrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

export { GameContentWrapper };
